module.exports = __webpack_public_path__ + "media/images/lp_team-1-b7f3cd0494c1b7bb5944e657cd06e1d2.webp";